import React from "react";

const SectionHeader = ({ text, color }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "40px 0 16px", paddingLeft: "50px",paddingRight: "50px" }}>
    <div
      style={{
        background: color, color: "#fff", fontSize: 16, fontWeight: 600,
        padding: "8px 22px",
        borderTopLeftRadius: 40, borderTopRightRadius: 40,
        borderBottomLeftRadius: 0, borderBottomRightRadius: 0,
        boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
        minWidth: 140, textAlign: "center",
      }}
    >
      {text}
    </div>
    <div style={{ height: 2, background: "#e2e6ea", flex: 1 }} />
  </div>
);

export default SectionHeader;
